var map = {
	"./index": 627,
	"./index.js": 627
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3997;



//////////////////
// WEBPACK FOOTER
// ./~/try-resolve ^\.\/.*$
// module id = 3997
// module chunks = 0